import React, { useState, useEffect } from 'react';

export default function CookieBanner({ onAccept, onDecline }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 1200); }, []);
  const accept  = () => { setVisible(false); setTimeout(onAccept, 300); };
  const decline = () => { setVisible(false); setTimeout(onDecline, 300); };

  return (
    <div style={{
      position:'fixed', bottom: visible ? 0 : '-100%', left:0, right:0,
      zIndex:9999, padding:'0 16px 16px',
      transition:'bottom 0.4s cubic-bezier(0.4,0,0.2,1)',
    }}>
      <div style={{
        maxWidth:'900px', margin:'0 auto',
        background:'#131729', border:'1px solid rgba(212,175,55,0.25)',
        borderRadius:'16px 16px 0 0', padding:'20px 24px',
        display:'flex', alignItems:'center', justifyContent:'space-between',
        gap:'20px', flexWrap:'wrap',
        boxShadow:'0 -8px 40px rgba(0,0,0,0.5)',
      }}>
        <div style={{ display:'flex', alignItems:'center', gap:'14px', flex:1 }}>
          <span style={{ fontSize:'28px', flexShrink:0 }}>🍪</span>
          <div>
            <p style={{ fontSize:'14px', fontWeight:700, color:'#F5F0E0', marginBottom:'3px' }}>
              We use cookies
            </p>
            <p style={{ fontSize:'13px', color:'#8892A4' }}>
              To improve your experience and analyze traffic.{' '}
              <a href="/privacy" style={{ color:'#D4AF37', fontWeight:600 }}>Learn more</a>
            </p>
          </div>
        </div>
        <div style={{ display:'flex', gap:'8px', flexShrink:0 }}>
          <button onClick={accept} style={{
            background:'#D4AF37', color:'#080B14', border:'none',
            borderRadius:'8px', padding:'10px 20px',
            fontFamily:'Inter,sans-serif', fontSize:'13px', fontWeight:700, cursor:'pointer',
          }}>
            Accept All
          </button>
          <button onClick={decline} style={{
            background:'transparent', color:'#8892A4',
            border:'1px solid rgba(212,175,55,0.2)', borderRadius:'8px',
            padding:'10px 20px', fontFamily:'Inter,sans-serif',
            fontSize:'13px', fontWeight:600, cursor:'pointer',
          }}>
            Essential Only
          </button>
        </div>
      </div>
    </div>
  );
}
